/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessNavigationModel {

        public workflowDesignerVisible: boolean;
        public processActionsVisible: boolean;
        public childProcessesVisible: boolean;
        public conditionsVisible: boolean;
        public calculationsVisible: boolean;
        public paymentsVisible: boolean;
        public emailSystemActionsVisible: boolean;
        public pdfGenerationSystemActionsVisible: boolean;
        public processDataVisible: boolean;
        public workflowVersionVisible: boolean;
        public assignmentConfigurationVisible: boolean;
        public processFormVisible: boolean;
        public processFormsVisible: boolean;
        public processEmailGroupsVisible: boolean;
        public timePeriodConfigurationVisible: boolean;
        public processClaimsVisible: boolean;
        public processStaticDocumentsVisible: boolean;
        public documentConfigVisible: boolean;
        public codesVisible: boolean;
        public constantsVisible: boolean;
        public dataSourcesVisible: boolean;
        public dataLinksVisible: boolean;
        public queriesVisible: boolean;
        public reviewConfigurationVisible: boolean;
        public scheduledResourcesConfigurationVisible: boolean;
        public interProcessApiVisible: boolean;
        public objectQueriesVisible: boolean;
        public objectQueryFormApiVisible: boolean;
        public processHeadersVisible: boolean;
        public mapToSystemStatusAndStatesVisible: boolean;
        public autoCompleteVisible: boolean;
        public apiVisible: boolean;
        public apiGridConfigurationVisible: boolean;
        public processSubTypesVisible: boolean;
        public batchJobsVisible: boolean;
        public relatedClaimProcessTypeVisible: boolean;
        public securityMatricesVisible: boolean;
        public gisDataStoreMetadataMapping: boolean;
        public processEventsVisible: boolean;
        public externalApiConfigurationVisible: boolean;
        public mapConfigurationVisible:boolean;
        public formContainersVisible: boolean;
        public processSecurityVisible: boolean;
        public apiConfigurationVisible: boolean;

        constructor(routeName: string) {
            switch (routeName) {
                case "Form":
                    this.processFormVisible = true;
                    break;
                case "FormContainers":
                    this.formContainersVisible = true;
                    break;
                case "GisDataStoreMetadata":
                    this.gisDataStoreMetadataMapping = true;
                    break;
                case "SecurityMatrices":
                    this.securityMatricesVisible = true;
                    break;
                case "ProcessSecurity":
                    this.processSecurityVisible = true;
                    break;
                case "RelatedClaimProcessType":
                    this.relatedClaimProcessTypeVisible = true;
                    break;
                case "MapConfiguration":
                    this.mapConfigurationVisible = true;
                    break
                case "AutoComplete":
                    this.autoCompleteVisible = true;
                    break;
                case "ApiGrid":
                    this.apiGridConfigurationVisible = true;
                    break;
                case "Api":
                    this.apiVisible = true;
                    break;
                case "BatchJobs":
                    this.batchJobsVisible = true;
                    break;
                case "ReviewConfigurations":
                    this.reviewConfigurationVisible = true;
                    break;
                case "Forms":
                    this.processFormsVisible = true;
                    break;
                case "Workflow":
                    this.workflowDesignerVisible = true;
                    break;
                case "ProcessActions":
                    this.processActionsVisible = true;
                    break;
                case "Codes":
                    this.codesVisible = true;
                    break;
                case "Claims":
                    this.processClaimsVisible = true;
                    break;
               case "ManageStaticDocuments":
                   this.processStaticDocumentsVisible = true;
                   break;
               case "DocumentConfiguration":
                   this.documentConfigVisible = true;
                   break;
                case "CustomUi":
                    this.childProcessesVisible = true;
                    break;
                case "Conditions":
                    this.conditionsVisible = true;
                    break;
                case "Calculations":
                    this.calculationsVisible = true;
                    break;
                case "Email":
                    this.emailSystemActionsVisible = true;
                    break;
                case "Payments":
                    this.paymentsVisible = true;
                    break;
                case "Pdf":
                    this.pdfGenerationSystemActionsVisible = true;
                    break;
                case "ProcessData":
                    this.processDataVisible = true;
                    break;
                case "ProcessEvents":
                    this.processEventsVisible = true;
                    break;
                case "AssigmentConfiguration":
                    this.assignmentConfigurationVisible = true;
                    break;
                case "TimePeriods":
                    this.timePeriodConfigurationVisible = true;
                    break;
                case "ScheduledResources":
                    this.scheduledResourcesConfigurationVisible = true;
                    break;
                case "InterProcessApis":
                    this.interProcessApiVisible = true;
                    break;
                case "EmailGroups":
                    this.processEmailGroupsVisible = true;
                    break;
                case "Version":
                    this.workflowVersionVisible = true;
                    break;
                case "Constants":
                    this.constantsVisible = true;
                    break;
                case "DataSources":
                    this.dataSourcesVisible = true;
                    break;
                case "DataLinks":
                    this.dataLinksVisible = true;
                    break;
                case "Queries":
                    this.queriesVisible = true;
                    break;
                case "ChildProcesses":
                    this.childProcessesVisible = true;
                    break;
                case "ObjectQueries":
                    this.objectQueriesVisible = true;
                    break;
                case "ObjectQueryFormsApi":
                    this.objectQueryFormApiVisible = true;
                    break;
                case "ProcessHeaders":
                    this.processHeadersVisible = true;
                    break;
                case "ProcessSubTypes":
                    this.processSubTypesVisible = true;
                    break;
                case "MapToSystemStatusAndStates":
                    this.mapToSystemStatusAndStatesVisible = true;
                    break;
                case "ExternalApiConfiguration":
                    this.externalApiConfigurationVisible = true;
                    break;
                case "ApiConfiguration":
                  this.apiConfigurationVisible = true;
                  break;
                default:
                    this.processFormsVisible = true;
            }
        }
    }
}